<template>
  <div>
    <!-- 商品维护列表页面 -->
    <div style="background: #fff">
      <el-tabs
        v-model="dataFromActive"
        type="card"
        :before-leave="tableLoading"
        @tab-click="handleTopTab"
      >
        <el-tab-pane label="标准商品" name="1"></el-tab-pane>
        <el-tab-pane label="非标商品" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :count="20"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div style="background: #fff">
      <el-tabs
        :key="currentName"
        v-model="currentName"
        type="card"
        :before-leave="tableLoading"
        @tab-click="handleTab"
      >
        <el-tab-pane
          v-for="item of tabArr"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="container">
      <!-- 操作按钮 -->
      <div v-if="listQuery.exportStatus" class="handle-wrapper">
        <eui-btn
          v-permission="['/product/skuManagement/skuPutawayBattch']"
          type="secondary"
          @click="handleManage"
        >
          {{ listQuery.exportStatus == 101 ? '下架' : '上架' }}
        </eui-btn>
        <eui-btn
          v-if="dataFrom === '1'"
          v-permission="['/product/skuManagement/updateSalesAreaScope']"
          type="secondary"
          @click="setAreaRule"
        >
          关联可售区域
        </eui-btn>
        <eui-btn
          v-if="dataFrom === '1'"
          v-permission="['/product/skuManagement/updateSkuPriceBatc']"
          type="secondary"
          @click="openAdjustPriceDialog"
        >
          多维度调价
        </eui-btn>
        <eui-btn
          v-if="dataFrom === '1'"
          v-permission="['/product/productExcel/importSkuTemplate']"
          type="secondary"
          @click="goToUrl('/batchEdit')"
        >
          批量导入修改
        </eui-btn>
        <eui-btn
          v-if="dataFrom === '1'"
          v-permission="['/skuManagement/updateSkuSalesScopeBattch']"
          type="secondary"
          @click="openSalesScope"
        >
          批量修改销售范围
        </eui-btn>
        <eui-btn
          v-if="dataFrom === '1'"
          v-permission="['/product/productExcel/downProductList']"
          type="secondary"
          :loading="downloadLoading"
          @click="downloadData"
        >
          数据导出
        </eui-btn>
        <eui-btn
          v-if="listQuery.exportStatus === 102"
          v-permission="['/product/skuManagement/skuDeleteBattch']"
          type="secondary"
          @click="deleteProducts(null)"
        >
          批量删除
        </eui-btn>
        <eui-btn
          v-if="currentIndex === 1 && dataFrom === '1'"
          v-permission="['/auditManagement/unsubmitReleaseImagesUpdate']"
          type="secondary"
          @click="openAssociatedImagesDialog"
        >
          关联图片
        </eui-btn>
        <eui-btn
          v-if="currentIndex === 0 && dataFrom === '1'"
          type="secondary"
          style="position: relative"
          @click="openExportDia"
        >
          我要出口
          <el-tooltip
            style="position: absolute; right: -28px; top: 6px"
            class="item"
            effect="dark"
            placement="top-start"
          >
            <div slot="content">
              如果您在推送商品出口中遇到问题，请联系global.epec@sinopec.com
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </eui-btn>
      </div>

      <div
        v-else-if="currentIndex === 4 && dataFrom === '1'"
        class="handle-wrapper"
      >
        <eui-btn
          v-if="relevanceImg"
          v-permission="['/auditManagement/unsubmitReleaseImagesUpdate']"
          type="secondary"
          @click="openAssociatedImagesDialog"
        >
          关联图片
        </eui-btn>

        <!-- <el-button v-permission="['/product/productExcel/downProductList']">数据导出</el-button> -->
        <eui-btn
          v-permission="['/product/auditManagement/unsubmitReleaseDelete']"
          type="secondary"
          @click="batchDelHandle"
        >
          批量删除
        </eui-btn>
      </div>

      <tableList
        ref="multipleTable"
        :table-data="tableData"
        :table-label="tableLabel"
        :selection-show="selectionShow"
        :row-key="rowKey"
        :loading="tableLoading"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #img="{ scope: { row } }">
          <el-image
            v-if="row.defaultImage"
            :src="row.defaultImage"
            :preview-src-list="[row.defaultImage]"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>

        <template #skuName="{ scope: { row } }">
          <el-link
            type="primary"
            @click="
              goToUrl(
                dataFrom === '1'
                  ? '/productDetail'
                  : '/goodsMaintenance/nonstandardDetail',
                {
                  [row.skuId ? 'skuId' : 'productAuditId']: row.skuId
                    ? row.skuId
                    : row.productAuditId,
                }
              )
            "
          >
            {{ row.skuName }}
          </el-link>
        </template>

        <template #pushStatus="{ scope: { row } }">
          <span>{{ getPushStatus(row.pushStatus) }}</span>
        </template>

        <template #skuStock="{ scope: { row } }">
          <innerEditTableBlur
            v-if="currentIndex === 0 || currentIndex === 1"
            :key="row.skuId"
            verify="skuStock"
            :row="row"
            :single.sync="row.skuStock"
            :edit="'skuStockEdit'"
            :placeholder="'请输入库存'"
            @confirmEdit="skuStockConfirmEdit"
          ></innerEditTableBlur>
        </template>

        <template #minOrderQuantity="{ scope: { row } }">
          <innerEditTableBlur
            v-if="currentIndex === 0 || currentIndex === 1"
            :key="row.skuId"
            verify="minOrderQuantityk"
            :row="row"
            :single.sync="row.minOrderQuantity"
            :edit="'minOrderQuantitykEdit'"
            :placeholder="'请输入起订量'"
            @confirmEdit="minOrderQuantityConfirmEdit"
          ></innerEditTableBlur>
        </template>

        <template #deliverTime="{ scope: { row } }">
          <innerEditTableBlur
            v-if="
              (currentIndex === 0 || currentIndex === 1) && dataFrom === '1'
            "
            :key="row.skuId"
            verify="deliverTime"
            :row="row"
            :single.sync="row.deliverTime"
            :edit="'deliverTimeEdit'"
            :placeholder="'请输入发货周期'"
            @confirmEdit="deliverTimeConfirmEdit"
          ></innerEditTableBlur>
          <span v-else-if="dataFrom === '2'">{{ row.leadTime }}</span>
          <span v-else>{{ row.deliverTime }}</span>
        </template>

        <template #price="{ scope: { row } }">
          <innerEditTableBlur
            v-if="currentIndex === 0 || currentIndex === 1"
            :key="row.skuId"
            verify="price"
            :row="row"
            :single.sync="row.price"
            :edit="'priceEdit'"
            :placeholder="'请输入市场价'"
            @confirmEdit="priceConfirmEdit"
          ></innerEditTableBlur>

          <span v-else>{{ row.price }}</span>
        </template>

        <template #systemSign="{ scope: { row } }">
          <span>{{ formatSource(row.systemSign) }}</span>
        </template>
        <template #taxRateValue="{ scope: { row } }">
          <el-select
            v-if="currentIndex === 1"
            v-model="row.taxRateId"
            placeholder="请选择税率"
            @change="taxRateChange($event, row)"
          >
            <el-option
              v-for="taxItem in taxList"
              :key="taxItem.taxRateId"
              :label="taxItem.taxRate"
              :value="taxItem.taxRateId"
            >
              <span>{{ taxItem.taxRate }}</span>
            </el-option>
          </el-select>
          <span v-else>
            {{ `${row.taxRateValue}%` }}
          </span>
        </template>

        <template #approvalOpinion="{ scope: { row } }">
          <el-tooltip hover class="error" effect="dark" placement="top-start">
            <span slot="content">{{ row.approvalOpinion }}</span>
            <span>审核拒绝</span>
          </el-tooltip>
        </template>

        <template #deliveryType="{ scope: { row } }">
          <el-select
            v-model="row.deliveryType"
            placeholder="请选择"
            @change="deliveryTypeChange($event, row)"
          >
            <el-option label="现货" :value="1"></el-option>
            <el-option label="期货" :value="2"></el-option>
          </el-select>
        </template>

        <template #salesScopeHeader>
          <span>销售范围</span>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              销售范围：是指您的商品对全平台客户的销售范围；
              <br />
              全平台：表示对平台所有客户销售；
              <br />
              仅协议客户：表示对您设置的平台协议客户，以协议价销售；
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #salesScope="{ scope: { row } }">
          <el-select
            v-model="row.salesScope"
            placeholder="请选择"
            @change="salesScopeChange($event, row)"
          >
            <el-option label="全平台" :value="1"></el-option>
            <el-option label="协议客户" :value="2"></el-option>
          </el-select>
        </template>

        <template #isConfirmHeader>
          <span>订单是否确认</span>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              选择”否”项表示不需要确认即生成有效订单，默认订单都需要确认。
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #isConfirm="{ scope: { row } }">
          <el-select
            v-model="row.isConfirm"
            placeholder="请选择"
            @change="isConfirmChange($event, row)"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </template>

        <template #denialReason="{ scope: { row } }">
          <span v-if="row.enable === 1 && row.exportStatus === 102"
            >人工下架</span
          >
          <el-tooltip
            v-else
            hover
            class="error"
            effect="dark"
            placement="top-start"
          >
            <span slot="content">{{ row.denialReason }}</span>
            <span>平台停用(原因)</span>
          </el-tooltip>
        </template>

        <template #sortNum="{ scope }">
          <div v-if="currentSortIndex !== scope.$index">
            <span class="overflow">{{
              scope.row.sortNum ? scope.row.sortNum : '-'
            }}</span>
            <el-button
              type="text"
              size="mini"
              @click="editSortNum(scope.$index, scope.row.skuId)"
            >
              <i class="title-icon el-icon-edit"></i>
            </el-button>
          </div>

          <el-input
            v-else
            id="inputRef"
            v-model.trim="scope.row.sortNum"
            class="edit-input"
            size="mini"
            style="width: 100%"
            @blur="sortNumConfirmEdit(scope.row.sortNum)"
            @focus="sortNumFocus"
            @input="
              scope.row.sortNum = scope.row.sortNum.replace(/[^0-9.]/g, '')
            "
          />
        </template>

        <template #operateHeader>
          <span>操作</span>
          <el-tooltip
            v-if="currentIndex === 1 || currentIndex === 4"
            class="item"
            effect="dark"
            placement="top-start"
          >
            <div slot="content">
              编辑商品的名称、图片，需要等待运营人员的审核
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #operate="{ scope: { row } }">
          <!-- 商品编辑 -->
          <eui-btn
            v-if="
              currentIndex === 1 &&
              (row.systemSign === 0 || row.systemSign === 1)
            "
            v-permission="['/auditManagement/productEditRelease']"
            type="link"
            :class="{ 'edit-info': row.auditStatus === 102 }"
            @click="
              goToUrl(
                dataFrom === '1'
                  ? '/productEdit'
                  : '/goodsMaintenance/nonstandardEdit',
                {
                  skuId: row.skuId,
                  auditStatus: row.auditStatus,
                }
              )
            "
          >
            编辑
          </eui-btn>
          <eui-btn
            v-if="
              (currentIndex === 0 || currentIndex === 1) && dataFrom === '1'
            "
            v-permission="['/auditManagement/productEditRelease']"
            type="link"
            :class="{ 'edit-info': row.auditStatus === 102 }"
            @click="previewProduct(row.skuId)"
          >
            预览
          </eui-btn>

          <!-- 审核编辑 -->
          <eui-btn
            v-if="
              currentIndex === 4 || (currentIndex === 1 && dataFrom === '2')
            "
            v-permission="['/auditManagement/productEditRelease']"
            type="link"
            @click="
              goToUrl(
                dataFrom === '1'
                  ? '/productEdit'
                  : '/goodsMaintenance/nonstandardEdit',
                {
                  [row.skuId ? 'skuId' : 'productAuditId']: row.skuId
                    ? row.skuId
                    : row.productAuditId,
                }
              )
            "
          >
            编辑
          </eui-btn>
          <eui-btn
            v-if="currentIndex === 2 && row.systemSign <= 1 && dataFrom === '1'"
            type="link"
            @click="handleWithdraw(row.productAuditId)"
          >
            撤回
          </eui-btn>

          <eui-btn
            v-if="currentIndex === 0 && dataFrom === '2'"
            type="link"
            @click="singleSkuNonstandard(row)"
          >
            下架
          </eui-btn>
          <eui-btn
            v-if="currentIndex === 1 && dataFrom === '2'"
            type="link"
            @click="deleteProducts(row)"
            >删除</eui-btn
          >
        </template>
      </tableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 区域调整弹窗 -->
    <area-dialog
      :area-form-visible.sync="areaFormVisible"
      :area-arr="areaArr"
      @areaHandle="areaHandle"
    />
    <!-- 多维度调价 -->
    <price-dialog
      :price-form-visible.sync="priceFormVisible"
      :price="adjustPrice"
      @handleAdjustPrice="handleAdjustPrice"
    />
    <!-- 批量修改销售范围 -->
    <sales-scope
      :sales-scope-visible.sync="salesScopeVisible"
      @salesScopeHandle="salesScopeHandle"
    />
    <!-- 维护图片弹窗 -->
    <associated-images
      ref="uploadImage"
      :associated-images-visible.sync="associatedImagesVisible"
      @getAllImageUrls="getAllImageUrls"
    />
    <!-- 出口弹窗 -->
    <export
      :export-dia-visible.sync="exportDiaVisible"
      :goods="pushGoods"
      :not-length="notPushGoodsLength"
      :all-length="multipleSelection.length"
      @pushExportSuccess="pushExportSuccess"
    />
    <!-- 预览 -->
    <previewDialog
      :dialog-visible.sync="previewProductVisible"
      :sku-id="skuId"
    ></previewDialog>
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import tableList from '@/modules/projectA/components/common/e-table-list';

import api from '@/modules/projectA/api/product';
import authorityApi from '@/modules/projectA/api/authority';
import utils from '@/modules/projectA/utils/utils';
import { nonstandardMap } from './mixins/index';

import AreaDialog from '../createProducts/components/areaDialog.vue';
import PriceDialog from '../createProducts/components/priceDialog.vue';
import SalesScope from '../createProducts/components/salesScope.vue';
import InnerEditTableBlur from '../components/innerEditTableBlur.vue';
import AssociatedImages from '../components/associatedImages.vue';
import Export from '../components/exportDia.vue';
import previewDialog from '../components/productDetail/previewDialog.vue';

export default {
  name: 'GoodsMaintenance',
  components: {
    AreaDialog,
    PriceDialog,
    SalesScope,
    InnerEditTableBlur,
    AssociatedImages,
    Export,
    previewDialog,
    eSearch,
    tableList,
  },
  filters: {
    areaFilter(value, areaArr) {
      if (!value) return '';
      const { salesScopeName = '' } =
        areaArr.find((item) => item.salesScopeId === value) || {};
      return salesScopeName;
    },
  },
  mixins: [nonstandardMap],
  props: {},
  data() {
    return {
      currentSortIndex: null,
      currentSkuId: null,
      exportDiaVisible: false,
      downloadLoading: false,
      dataFrom: '1',
      dataFromActive: '1',
      currentIndex: 0,
      currentName: '0',
      tabArr: [
        { label: '已上架商品', name: '0' },
        { label: '已下架商品', name: '1' },
        { label: '审核中', name: '2' },
        { label: '审核通过', name: '3' },
        { label: '审核拒绝', name: '4' },
      ],
      associatedImagesVisible: false,
      rowKey: 'skuId',
      salesScopeVisible: false,
      // 调整价格
      priceFormVisible: false,
      // 设置区域
      areaArr: [],
      areaFormVisible: false,
      listQuery: {
        exportStatus: 101,
        pageNum: 1,
        pageSize: 10,
        systemSign: null,
        skuName: null,
        pushStatus: null,
        salesScope: null,
        agreementName: null,
        brandName: null,
        salesScopeId: null,
        productType: null,
        sortNumScreen: null,
      },
      cloneListQuery: {},
      total: 0,
      allTotal: 0,
      tableLoading: false,
      tableData: [],
      // 选中的列表数据
      multipleSelection: [],
      showListVisible: false,
      adjustPrice: 0,
      relevanceImg: true,
      // 能推送的商品
      pushGoods: [],
      // 不能推送商品的长度
      notPushGoodsLength: 0,
      previewProductVisible: false,
      skuId: 0,
    };
  },
  computed: {
    fieldList() {
      return this.fieldListAll.filter((item) => {
        if (this.dataFrom === '1') {
          if (item.hidden) {
            return !item.hidden.includes(this.currentIndex);
          }
          return true;
        }
        if (this.dataFrom === '2') {
          if (
            (this.currentIndex === 3 || this.currentIndex === 4) &&
            (item.label === '提交时间' || item.label === '审核时间')
          ) {
            return true;
          }
          if (item.hidden) {
            return (
              !item.hidden.includes(this.currentIndex) &&
              !item.hidden.includes(this.dataFrom)
            );
          }
          return true;
        }
        return false;
      });
    },
    tableLabel() {
      return this.tableLabelAll.filter((item) => {
        if (this.dataFrom === '1') {
          if (item.hidden) {
            return !item.hidden.includes(this.currentIndex);
          }
          return true;
        }
        if (this.dataFrom === '2') {
          if (item.label === '发货周期(天)') {
            return true;
          }
          if (this.currentIndex === 0 && item.label === '审核时间') {
            return false;
          }
          if (
            (this.currentIndex === 3 || this.currentIndex === 4) &&
            item.label === '提交时间'
          ) {
            return true;
          }
          if (item.hidden) {
            return (
              !item.hidden.includes(this.currentIndex) &&
              !item.hidden.includes(this.dataFrom)
            );
          }
          return true;
        }
        return false;
      });
    },
    selectionShow() {
      if (this.dataFrom === '1') {
        return [0, 1, 4].includes(this.currentIndex);
      }
      if (this.dataFrom === '2') {
        return [0, 1].includes(this.currentIndex);
      }
      return false;
    },
  },
  activated() {
    // 当组件被缓存后再次激活时调用
    console.log('组件被激活（重新渲染）');
    console.log(this.listQuery.auditStatus, 'this.listQuery.auditStatus');
    console.log(this.listQuery.exportStatus, 'this.listQuery.exportStatus');
    if (this.listQuery?.auditStatus === 104) {
      this.getAuditList(this.listQuery);
    }
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.listQuery.dataFrom = 1;
    this.handleTab({ label: '已上架商品', name: '0' });
    this.getAreaArr();
    this.getTaxRateList();
  },
  methods: {
    beforeLeave(activeName, oldActiveName) {
      console.log(activeName, oldActiveName, 'activeName, oldActiveName');
      if (this.tableLoading) {
        return this.tableLoading;
      }
    },
    formatSource(systemSign) {
      const { name = '' } =
        this.listTypeInfo.systemSignList.find(
          (item) => item.id === systemSign
        ) || {};
      return name || '系统集成';
    },

    editSortNum(idx, skuId) {
      console.log(skuId);
      if (this.currentSkuId !== null) {
        return false;
      }
      this.currentSortIndex = idx;
      this.currentSkuId = skuId;

      this.$nextTick(() => {
        document.getElementById('inputRef').focus();
      });
      return true;
    },
    previewProduct(skuId) {
      this.skuId = skuId;
      this.previewProductVisible = true;
    },
    pushExportSuccess(val) {
      if (val === 'success') {
        this.handleFilter(this.listQuery);
      }
      this.$refs.multipleTable.$refs.table.clearSelection(); // 清除全部的选中状态
    },
    getPushStatus(status) {
      const { name = '' } =
        this.listTypeInfo.pushStatusList.find((item) => item.id === status) ||
        {};
      return name || '未推送';
    },
    openExportDia() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.pushGoods = this.multipleSelection.filter(
        (item) =>
          item.pushStatus === 2 ||
          item.pushStatus === 3 ||
          item.pushStatus === undefined
      );
      console.log('选中的总条数:', this.multipleSelection.length);
      console.log('可以推送的条数:', this.pushGoods.length);
      this.notPushGoodsLength =
        this.multipleSelection.length - this.pushGoods.length;
      console.log('不可以推送的条数:', this.notPushGoodsLength);
      this.exportDiaVisible = true;
    },
    async getTaxRateList() {
      const res = await api.getTaxRateList();
      if (res.code === '200') {
        console.log(res.data, 'res.datares.data');
        res.data.forEach((item) => {
          item.taxRate += '';
        });
        this.taxList = res.data;
        console.log(this.taxList, 'this.taxList');
      }
    },
    handleTopTab(tab, event) {
      console.log(tab.name, this.dataFrom);
      if (tab.name === this.dataFrom) {
        return;
      }
      console.log('tab:', tab);
      console.log('event:', event);
      this.dataFrom = tab.name;
      this.listQuery.dataFrom = Number(tab.name);
      this.cloneListQuery.dataFrom = Number(tab.name);
      this.listQuery = { ...this.cloneListQuery };
      this.getAllList(this.listQuery);
      this.currentIndex = 0;
      this.currentName = '0';
    },
    // tab切换
    async handleTab(tab) {
      console.log('handleTab-tab:', tab);
      const res = await authorityApi.queryBackButton({
        authCode: '/goodsMaintenance',
      });
      this.$store.commit('button_directive', res.data);
      this.relevanceImg = res.data.some(
        (item) =>
          item.authCode === '/auditManagement/unsubmitReleaseImagesUpdate'
      );
      this.currentIndex = Number(tab.name);
      this.multipleSelection = [];
      this.listQuery = { ...this.listQuery, ...this.cloneListQuery };
      // 切换的时候清楚选中
      this.$refs.multipleTable.$refs.table.clearSelection();

      switch (this.currentIndex) {
        case 0:
          this.rowKey = 'skuId';
          delete this.listQuery.auditStatus;
          Object.assign(this.listQuery, { exportStatus: 101 });
          this.getAllList(this.listQuery);
          break;
        case 1:
          this.rowKey = 'skuId';
          delete this.listQuery.auditStatus;
          Object.assign(this.listQuery, { exportStatus: 102 });
          this.getAllList(this.listQuery);
          break;
        case 2:
          this.rowKey = 'productAuditId';
          delete this.listQuery.exportStatus;
          Object.assign(this.listQuery, { auditStatus: 102 });
          this.getAuditList(this.listQuery);
          break;
        case 3:
          this.rowKey = 'productAuditId';
          delete this.listQuery.exportStatus;
          Object.assign(this.listQuery, { auditStatus: 101 });
          this.getAuditList(this.listQuery);
          break;
        case 4:
          this.rowKey = 'productAuditId';
          delete this.listQuery.exportStatus;
          Object.assign(this.listQuery, { auditStatus: 104 });
          this.getAuditList(this.listQuery);
          break;
        default:
          break;
      }
      // 防止切换后刷新还在当前currentIndex tab
      window.location.hash = window.location.hash.split('?')[0];
    },
    openAssociatedImagesDialog() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.$refs.uploadImage.initData();
      this.associatedImagesVisible = true;
      this.$refs.uploadImage.initData();
    },
    // 维护图片提交
    async getAllImageUrls(val) {
      if (this.currentIndex === 4) {
        // 审核拒绝
        const productAuditIds = this.multipleSelection.map(
          (item) => item.productAuditId
        );
        console.log(this.multipleSelection, 'this.multipleSelection');
        const params = { productAuditIds };
        params.defaultImage = val.imageUrls[0] || val.imageUrlsExist[0];
        Object.assign(params, val);
        const { unsubmitReleaseImagesUpdate } = api;
        const res = await unsubmitReleaseImagesUpdate(params);
        if (+res.code === 200) {
          this.$message({
            message: '关联图片成功！',
            type: 'success',
          });
          Object.assign(this.listQuery, { auditStatus: 104 });
          this.getAuditList(this.listQuery);
          this.associatedImagesVisible = false;
          this.$refs.multipleTable.$refs.table.clearSelection();
        }
      } else {
        // 下架商品
        const productSkuIdList = this.multipleSelection.map(
          (item) => item.skuId
        );
        console.log(this.multipleSelection, 'this.multipleSelection');
        const params = { productSkuIdList };
        Object.assign(params, val);
        const imageUrls = [...params.imageUrls, ...params.imageUrlsExist];
        const detailImageUrls = [
          ...params.detailImageUrls,
          ...params.detailImageUrlsExist,
        ];
        // params.detailImageUrls = params.imageUrls[0] || params.imageUrlsExist[0];
        params.imageUrls = imageUrls;
        params.detailImageUrls = detailImageUrls;
        console.log(params, '下架维护图片');
        const { modifyProductImages } = api;
        const res = await modifyProductImages(params);
        if (+res.code === 200) {
          this.$message({
            message: '关联图片成功！',
            type: 'success',
          });
          Object.assign(this.listQuery, { exportStatus: 102 });
          this.getAllList(this.listQuery);
          this.associatedImagesVisible = false;
          this.$refs.multipleTable.$refs.table.clearSelection();
        }
      }
    },
    // 停用商品不能选择了，不能上架
    /* checkboxSelect(row) {
      console.log(row);
      if (row.enable === 1) {
        return true;
      } else {
        return false;
      }
    }, */
    // 审核失败删除
    batchDelHandle() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要删除的数据',
          type: 'warning',
        });
        return;
      }
      this.$confirm('删除后不可恢复，确认要删除商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const productAuditIds = this.multipleSelection.map(
            (item) => item.productAuditId
          );
          console.log(productAuditIds);
          console.log(this.multipleSelection);
          api
            .unsubmitReleaseDelete(productAuditIds)
            .then((res) => {
              if (res.code === '200') {
                this.$refs.multipleTable.$refs.table.clearSelection();
                this.listQuery.pageNum = 1;
                this.getAuditList(this.listQuery);
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 修改订单是否确认
    async isConfirmChange(data, row) {
      console.log(data, row);
      const params = {
        skuId: row.skuId,
        isConfirm: Number(data),
      };
      const { updateSkuIsConfirm } = api;
      const res = await updateSkuIsConfirm(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改税率
    async taxRateChange(data, row) {
      const params = {
        skuId: row.skuId,
      };
      const taxObj =
        this.taxList.find((item) => {
          return item.taxRateId === row.taxRateId;
        }) || {};
      taxObj.taxRateValue = Number(taxObj.taxRate);
      Object.assign(params, taxObj);
      const { taxRateEdite } = api;
      const res = await taxRateEdite(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 可售范围修改
    async salesScopeChange(data, row) {
      const params = {
        skuId: row.skuId,
        salesScope: Number(data),
      };
      const { updateSkuSalesScope } = api;
      const res = await updateSkuSalesScope(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    async deliveryTypeChange(data, row) {
      const params = {
        skuId: row.skuId,
        deliveryType: Number(data),
      };
      const { updateSkuDeliveryType } = api;
      const res = await updateSkuDeliveryType(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改库存 ｜｜
    async skuStockConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        skuStock: Number(data),
      };
      const { updateSkuStock } = api;
      const res = await updateSkuStock(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改起订量 ｜｜
    async minOrderQuantityConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        minOrderQuantity: Number(data),
      };
      const { updateOrderMinOrderQuantity } = api;
      const res = await updateOrderMinOrderQuantity(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改发货周期 ｜｜
    async deliverTimeConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        deliverTime: data,
      };
      const { updateSkuDeliverTime } = api;
      const res = await updateSkuDeliverTime(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改市场价格 ｜｜
    async priceConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        price: Number(data),
      };
      const { updateSkuPrice } = api;
      const res = await updateSkuPrice(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    sortNumFocus() {
      console.log('focus');
    },
    async sortNumConfirmEdit(val) {
      this.tableLoading = true;
      console.log(val);
      const numberRegPositive = /^[1-9]\d*$/; // 正整数不包含0
      if (val !== '' && !numberRegPositive.test(val)) {
        this.$message.error('请输入正整数');
        this.tableLoading = false;
        this.$nextTick(() => {
          document.getElementById('inputRef').focus();
        });
        return false;
      }
      if (val > 9999) {
        this.$message.error('请输入小于等于9999的正整数');
        this.tableLoading = false;
        val = 9999;
        this.$nextTick(() => {
          document.getElementById('inputRef').focus();
        });
        return false;
      }
      console.log(this.currentSkuId);
      const params = {
        skuId: this.currentSkuId,
        sortNum: val,
      };
      const res = await api.updateSkuSortNum(params);
      if (res.code === '200') {
        this.tableLoading = false;
        this.currentSortIndex = null;
        this.currentSkuId = null;
      } else {
        this.getAllList(this.listQuery);
      }
      return true;
    },
    //
    // 数据导入
    async downloadData() {
      const params = {};
      Object.assign(params, this.listQuery);
      params.pageSize = this.total;
      console.log(params);
      this.downloadLoading = true;
      const res = await api.downProductList(params);
      this.downloadLoading = false;
      if (res.size !== 0) {
        utils.downFile(res);
      }
    },
    // 跳转链接
    goToUrl(url, row = {}) {
      // , auditStatus = ""
      const { skuId = '', productAuditId = '' } = row;
      if (skuId) {
        this.$router.push({
          path: url,
          query: { skuId, currentIndex: this.currentIndex },
        });
        return;
      }
      if (this.listQuery.auditStatus === 104 && productAuditId) {
        this.$router.push({
          path: url,
          query: {
            productAuditId,
            auditStatus: 104,
            currentIndex: this.currentIndex,
          },
        });
        return;
      }
      if (productAuditId) {
        this.$router.push({
          path: url,
          query: { productAuditId, currentIndex: this.currentIndex },
        });
        return;
      }
      this.$router.push({ path: url });
    },
    handleWithdraw(productAuditId) {
      // 集成商品不支持撤回
      this.$confirm(
        '<strong>您要撤回该商品的申请吗？不可恢复！</strong><br/><span>撤回后可以商品发布列表页面进行再次编辑</span>',
        '撤回',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          const result = await api.modifyRevokeSubmitReview({ productAuditId });
          if (result.code === '200') {
            this.$message({
              type: 'success',
              message: '撤回成功!',
            });
            this.getAuditList(this.listQuery);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤回',
          });
        });
    },
    // 点击是否展示列表项设置
    showListHandle() {
      this.showListVisible = !this.showListVisible;
    },
    handleCellClick(row, column) {
      if (column.property === 'skuName') {
        this.$router.push({
          path: 'productDetail',
          query: { productId: row.productId },
        });
      }
    },

    // 删除下架商品
    deleteProducts(row) {
      const params = { dataFrom: Number(this.dataFrom) };
      if (row) {
        const { skuId } = row;
        params.skuIds = [skuId];
      } else if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      } else {
        params.skuIds = this.multipleSelection.map((item) => item.skuId);
      }

      this.$confirm('确定删除所选?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          api.skuDeleteBattch(params.skuIds).then((res) => {
            if (res.code === '200') {
              this.getAllList(this.listQuery);
              this.$refs.multipleTable.$refs.table.clearSelection();
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 批量修改销售范围
    openSalesScope() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.salesScopeVisible = true;
    },
    // 批量修改销售范围
    async salesScopeHandle(salesScope) {
      const skuIds = this.multipleSelection.map((item) => item.skuId);
      const params = {
        salesScope,
        skuIds,
      };
      const { updateSkuSalesScopeBattch } = api;
      const res = await updateSkuSalesScopeBattch(params);
      if (+res.code === 200) {
        this.$message({
          message: '销售范围修改成功！',
          type: 'success',
        });
        this.getAllList(this.listQuery);
        this.$refs.multipleTable.$refs.table.clearSelection();
        this.salesScopeVisible = false;
      }
    },
    // 多维度调价
    openAdjustPriceDialog() {
      // updateSkuPriceBatch
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.priceFormVisible = true;
      const priceArr = this.multipleSelection.map((item) => item.price);
      this.adjustPrice = Math.min(...priceArr);
    },
    async handleAdjustPrice(val) {
      const params = { ...val };
      const skus = this.multipleSelection.map((item) => ({
        skuId: item.skuId,
      }));
      params.skus = skus;
      const { updateSkuPriceBatch } = api;
      const res = await updateSkuPriceBatch(params);
      if (res.code === '200') {
        this.priceFormVisible = false;
        this.$message({
          message: '多维度调价成功！',
          type: 'success',
        });
        this.getAllList(this.listQuery);
        this.$refs.multipleTable.$refs.table.clearSelection();
      }
    },
    // 获取全部接口-上下架
    async getAllList(params) {
      this.tableData = [];
      try {
        this.tableLoading = true;
        const { querySkuByPage } = api;
        const res = await querySkuByPage(params);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data.records];
          this.total = data.total;
        }
      } catch (err) {
        console.log(err);
        this.tableLoading = false;
      }
    },
    // 获取审核的接口
    async getAuditList(params) {
      this.tableData = [];
      try {
        const { queryReleaseProductByPage } = api;
        this.tableLoading = true;
        const res = await queryReleaseProductByPage(params);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data.records];
          this.total = data.total;
        }
      } catch (err) {
        this.tableLoading = false;
        console.log(err);
      }
    },

    // 获取区域列表
    async getAreaArr() {
      const { querySalesScopeList } = api;
      await querySalesScopeList()
        .then((res) => {
          if (res.code === '200') {
            this.areaArr = [...res.data];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 关联可售区域
    setAreaRule() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需处理的列表的数据',
          type: 'warning',
        });
        return;
      }
      this.areaFormVisible = true;
    },
    // 关联可售区域确定
    async areaHandle(salesScopeId) {
      const skuIds = this.multipleSelection.map((item) => item.skuId);
      await api
        .updateSalesAreaScope({ skuIds, salesScopeId })
        .then((res) => {
          if (res.code === '200') {
            delete this.cloneListQuery.auditStatus;
            this.$refs.multipleTable.$refs.table.clearSelection(); // 清除全部的选中状态
            this.cloneListQuery.exportStatus = this.listQuery.exportStatus;
            this.getAllList(this.cloneListQuery);
            this.$message({
              message: '可售区域设置成功',
              type: 'success',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$refs.multipleTable.$refs.table.clearSelection();
          this.areaFormVisible = false;
        });
    },
    //
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      if (this.listQuery.exportStatus) {
        this.getAllList(this.listQuery);
      } else {
        this.getAuditList(this.listQuery);
      }
    },
    // 改变条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      if (this.listQuery.exportStatus) {
        this.getAllList(this.listQuery);
      } else {
        this.getAuditList(this.listQuery);
      }
    },
    // 列表搜索
    handleFilter(val) {
      this.listQuery.startAuditTime = val.updateTime?.length
        ? val.updateTime[0]
        : '';
      this.listQuery.endAuditTime = val.updateTime?.length
        ? val.updateTime[1]
        : '';
      this.listQuery.startTime = val.auditTime?.length ? val.auditTime[0] : '';
      this.listQuery.endTime = val.auditTime?.length ? val.auditTime[1] : '';
      Object.assign(this.listQuery, val);
      this.listQuery.pageNum = 1;
      if (this.listQuery.exportStatus) {
        this.getAllList(this.listQuery);
      } else {
        this.getAuditList(this.listQuery);
      }
      this.$refs.multipleTable.$refs.table.clearSelection();
    },
    // 列表搜索重置
    handleReset() {
      if (this.listQuery.exportStatus) {
        delete this.cloneListQuery.auditStatus;
        this.cloneListQuery.exportStatus = this.listQuery.exportStatus;
        this.getAllList(this.cloneListQuery);
      } else {
        delete this.cloneListQuery.exportStatus;
        this.cloneListQuery.auditStatus = this.listQuery.auditStatus;
        this.getAuditList(this.cloneListQuery);
      }
      this.listQuery = { ...this.cloneListQuery };
      this.$refs.multipleTable.$refs.table.clearSelection();
    },
    handleEdit(val) {
      this.$router.push({ path: '/productEdit', query: { productId: val } });
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },

    // 商品上架-下架
    handleManage() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      const message =
        this.listQuery.exportStatus === 101
          ? '下架商品请在“已下架商品”标签页查看,确定下架吗?'
          : '上架商品请在“已上架商品”标签页查看,确定上架吗?';
      const skuIds = this.multipleSelection.map((item) => item.skuId);
      console.log(skuIds);
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (this.listQuery.exportStatus === 101) {
            this.handleSoldOut(skuIds);
          } else if (this.listQuery.exportStatus === 102) {
            this.handlePutaway(skuIds);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },

    // 商品下架-标品
    handleSoldOut(skuIds) {
      api
        .skuSoldOutBattch(skuIds)
        .then((res) => {
          if (res.code === '200') {
            this.listQuery.pageNum = 1;
            this.$refs.multipleTable.$refs.table.clearSelection(); // 清除全部的选中状态
            this.getAllList(this.listQuery);
            this.$message({
              type: 'success',
              message: '商品下架成功!',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 单个下架
    singleSkuNonstandard(row) {
      const { skuId, dataFrom } = row;
      const skuIds = [skuId];
      const params = {
        dataFrom,
        skuIds,
      };
      this.$confirm('下架商品请在“已下架商品”标签页查看,确定下架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.handleSoldOut(params.skuIds);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 商品上架
    handlePutaway(skuIds) {
      api
        .skuPutawayBattch(skuIds)
        .then((res) => {
          if (res.code === '200') {
            this.listQuery.pageNum = 1;
            this.getAllList(this.listQuery);
            this.$refs.multipleTable.$refs.table.clearSelection();
            this.$message({
              type: 'success',
              message: '商品上架成功!',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs {
  .el-tabs__header {
    margin-bottom: 0;
  }
}
.icon-question {
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  color: #c5c5c5;
  display: inline-block;
  margin-left: 10px;
  &:hover {
    color: #fff;
    background-color: #c5c5c5;
  }
}
.tab-content {
  display: flex;
  align-items: center;
  position: relative;
  .tab-btn {
    position: relative;
    height: 40px;
    line-height: 40px;
    flex: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    font-weight: 500;
    padding: 0 20px;
    font-size: 14px;
    border-left: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    &:last-child {
      border-right: 0;
    }
    &:first-child {
      border-left: 0;
    }
    &.active {
      background: #f4f7ff;
      color: #0064c8;
      height: 40px;
      line-height: 40px;
      &::after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        content: '';
        width: 100%;
        height: 2px;
        background: #0064c8;
      }
    }
  }
}
.create-product {
  ::v-deep .el-image {
    width: 48px;
    height: 48px;
    display: block;
    font-size: 0;
    ::v-deep img {
      display: block;
      width: 100%;
      width: 100%;
    }
  }

  .wran-msg {
    background: #e8efff;
    padding: 15px 10px;
    color: #333333;
    display: flex;
    font-size: 14px;
    margin-bottom: 20px;
    .bold {
      display: inline-block;
      font-weight: bold;
      text-align: right;
      color: #f0250f;
      flex-shrink: 0;
      flex-grow: 0;
      // flex-basis: 82px;
    }
  }

  .error {
    color: red;
    cursor: pointer;
  }
}
</style>
<style>
.el-tooltip__popper {
  max-width: 320px;
}
</style>
